import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { MethodSection } from './MethodSection';
import { WhatYouGet } from './WhatYouGet';
import { AudienceSection } from './AudienceSection';
import { TestimonialsSection } from './TestimonialsSection';
import { TrustSection } from './TrustSection';
import { FaqSection } from './FaqSection';
import { PriceSection } from './PriceSection';
import { Footer } from './Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-brand-light font-sans selection:bg-brand-accent selection:text-white" data-id="element-167">
      <HeroSection data-id="element-168" />
      <ProblemSection data-id="element-169" />
      <MethodSection data-id="element-170" />
      <WhatYouGet data-id="element-171" />
      <AudienceSection data-id="element-172" />
      <TestimonialsSection data-id="element-173" />
      <TrustSection data-id="element-174" />
      <FaqSection data-id="element-175" />
      <PriceSection data-id="element-176" />
      <Footer data-id="element-177" />
    </div>;
}